import type { ImageReference } from './types';

export const CITATION_RE = /\[\[(?:DOC:)?(\d+)\]\]/g;
export const IMG_CITATION_RE = /\[\[IMG:(\d+)\]\]/g;

export function normalizeCitationGroups(text: string): string {
  return text.replace(/\[\[([^\]]+(?:\]\s*,\s*\[[^\]]+)*)\]\]/g, (match) => {
    if (/IMG:/i.test(match)) return match;
    const nums = match.match(/\d+/g) ?? [];
    if (nums.length === 0) return match;
    return nums.map((n) => `[[${n}]]`).join(' ');
  });
}

export function extractCitationIndices(text: string): number[] {
  const citedIndices: number[] = [];
  const seen = new Set<number>();

  for (const match of normalizeCitationGroups(text).matchAll(CITATION_RE)) {
    const index = parseInt(match[1], 10);
    if (!seen.has(index)) {
      seen.add(index);
      citedIndices.push(index);
    }
  }

  return citedIndices;
}

export function resolveImageMarkdown(text: string, images?: ImageReference[]): string {
  if (!images || images.length === 0) {
    return text.replace(IMG_CITATION_RE, '[IMG:$1]');
  }

  return text.replace(IMG_CITATION_RE, (_, n: string) => {
    const idx = parseInt(n, 10);
    const img = images.find((entry) => entry.index === idx);
    if (!img) return `[IMG:${n}]`;
    const url = `/api/dotnet/blobs/${img.blob_key}`;
    const alt = img.caption ?? `Bild ${n}`;
    return `\n\n![${alt}](${url} "Abbildung ${n}")\n\n`;
  });
}